const validate = (value, {from, to, inclusion = true}) => {
    if (Array.isArray(value)) {
        return value.every(val => validate(val, {from, to, inclusion}))
    }

    if( inclusion ) {
        return Number(from) <= value && Number(to) >= value
    } else {
        return Number(from) < value && Number(to) > value
    }
}

export default validate
